import { useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  SelectChangeEvent,
  MenuItem,
} from "@mui/material";
import { initialParamData, ParamData } from "../../../types/Param";
import DailyAudit from "./DailyAudit";
import { getEntityListData } from "../../../api/AuditApi";

const DailyAuditCard = () => {
  const [paramData, setParamData] = useState<ParamData>(initialParamData);
  const [entities, setEntities] = useState<string[]>([]);

  const handleChange = (
    e:
      | React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
      | SelectChangeEvent
  ) => {
    const { name, value } = e.target;

    setParamData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const initializeEntity = async () => {
    setParamData((prev) => ({
      ...prev,
      entity: entities.length > 0 ? entities[0] : "",
    }));
  };

  const loadListData = async () => {
    const entities = await getEntityListData();
    await setEntities(entities);
  };

  useEffect(() => {
    loadListData();
    initializeEntity();
  }, []);

  useEffect(() => {
    initializeEntity();
  }, [entities]);

  return (
    <Box
      sx={{
        bgcolor: "white",
        p: 2,
        borderRadius: 2,
        boxShadow: 2,
        minHeight: 180,
      }}
    >
      <Typography variant="subtitle1" fontWeight="bold" mb={2}>
        Audit Log
      </Typography>
      <Box
        sx={{
          display: "flex",
          gap: 2,
          flexWrap: "wrap",
        }}
      >
        <TextField
          select
          name="entity"
          label="Select Entity"
          size="small"
          value={paramData.entity}
          onChange={handleChange}
          sx={{
            width: { xs: "100%", sm: "30%" },
          }}
        >
          {entities.map((e) => (
            <MenuItem key={e} value={e}>
              {e}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          type="date"
          name="startingFrom"
          label="Start Date"
          size="small"
          InputLabelProps={{ shrink: true }}
          value={paramData.startingFrom}
          onChange={handleChange}
          sx={{
            width: { xs: "100%", sm: "30%" },
          }}
        />

        <TextField
          type="date"
          name="endingOn"
          label="End Date"
          size="small"
          InputLabelProps={{ shrink: true }}
          value={paramData.endingOn}
          onChange={handleChange}
          sx={{
            width: { xs: "100%", sm: "30%" },
          }}
        />
      </Box>

      <DailyAudit data={paramData} />
    </Box>
  );
};

export default DailyAuditCard;
